module.exports = __webpack_public_path__ + "images/photo-shooting-ffa01fb92a0186be1b6ecaacaf8a5033.svg";